"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventsListenerHook = void 0;
var react_1 = require("react");
exports.createEventsListenerHook = function (events) {
    return function (event, action, dependencies) {
        if (dependencies === void 0) { dependencies = []; }
        react_1.useEffect(function () {
            var fn = function (data) { return action(data); };
            events.on(event, fn);
            return function () { return events.off(event, fn); };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, dependencies);
    };
};
// EXAMPLE
// const useEventsListener = createEventsListenerHook(events)
